import _ from 'lodash'
import Translate from 'modules/local/Translate'
import React from 'react'
import {NullAsDefault} from 'views/Shared'
import {getFullAddress, renderIf, renderIfElse} from "../../../Shared";
import dayjs from "dayjs"
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {GiFlyingFlag, GiJeweledChalice} from "react-icons/gi";
import {GoDotFill} from "react-icons/go";
import {BiSolidChurch, BiSolidMapPin} from "react-icons/bi";
import {FaChurch} from "react-icons/fa6";
import CRUD from "../../../Shared/enums/CRUD";
import {LocalContext} from "../../../../modules/local/LocalContext";
import {RiMapPinTimeFill} from "react-icons/ri";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import TooltipApp from "components/TooltipApp";
import {renderDayOfWeek} from "./renderDayOfWeek";
import {formatDate} from "../../../../helpers/datetimeHelpers";
import {TbEdit} from "react-icons/tb";

dayjs.extend(customParseFormat);

export const renderChurchMassTime = ({translate: t, showChurch = false, renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {
    const {
        church,
        title,
        description,
        start_time,
        language,
        special_event_flag,
        special_event_datetime,
        sunday_mass_flag,
    } = item ?? {}

    const {name} = church ?? {}
    const fullAddress = getFullAddress(church)
    const startTime = dayjs(start_time, "HH:mm:ss")
    const time = formatDate(startTime, 'HH:mm')
    const week_label = renderDayOfWeek(item?.weekdays)
    const displayTime = special_event_flag === 1
        ? formatDate(special_event_datetime, 'HH:mm')
        : time

    return (
        <div key={index} className="py-2 flex flex-col">
            {/* Main row: icon | TIME (hero) | title+sublabel | lang | actions */}
            <div className="flex items-center gap-3 ">

                {/* TIME — hero */}
                <span className="font-mono font-bold text-2xl text-orange-500 flex-shrink-0 leading-none">
                    {displayTime}
                </span>

                <div className="flex flex-col ">
                    <div className="font-semibold leading-snug truncate">
                        {title}
                    </div>
                    {!!description && (
                        <p className="text-xs text-color-400 tracking-wider leading-snug">
                            {description}
                        </p>
                    )}
                </div>
                {/* Title + sublabel */}
                {special_event_flag === 1 && (
                    <div className="flex items-center gap-1 mt-0.5">
                        <GiFlyingFlag size={10} className="text-green-500 flex-shrink-0"/>
                        <span className="text-2xs text-green-600 italic leading-none">
                            {formatDate(special_event_datetime, 'DD/MM/YYYY')}
                        </span>
                    </div>
                )}
                {renderIf(
                    language !== 'vi',
                    <span className="text-2xs font-bold text-primary italic opacity-60 flex-shrink-0">
                        {t(language)}
                    </span>
                )}

                <div className="flex-1"/>

                {/* Admin actions */}
                <div className="flex items-center gap-2 flex-shrink-0">
                    {renderIf(
                        !showChurch && !!item?.edit,
                        <TooltipApp title={t('edit mass times')} placement="left" classNames={{root: "font-medium text-xs italic"}}>
                            <div
                                onClick={() => handleAction(CRUD.UPDATE, item)}
                                style={{width: 28, height: 28}}
                                className="flex flex-center hover:bg-blue-50 rounded-lg text-blue-500 hover:text-blue-700 cursor-pointer">
                                <TbEdit size={15}/>
                            </div>
                        </TooltipApp>
                    )}
                    {renderIf(
                        !!item?.edit && _.isFunction(renderContextMenu),
                        renderContextMenu(item)
                    )}
                </div>
            </div>

            {renderIf(
                showChurch,
                <div className="flex flex-col md:flex-row gap-x-8 gap-y-1 mt-2 ml-6">
                    <div className="flex items-start gap-2">
                        <BiSolidChurch size={13} className="text-color-400 flex-shrink-0 mt-0.5"/>
                        <span
                            onClick={() => handleAction(CRUD.READ, item)}
                            className="font-semibold text-xs text-color-200 hover:text-primary italic leading-snug cursor-pointer">
                            {name}
                        </span>
                    </div>
                    <div className="flex items-start gap-2">
                        <BiSolidMapPin size={13} className="text-color-400 flex-shrink-0 mt-0.5"/>
                        <span className="font-semibold text-xs text-color-200 italic leading-snug">
                            {fullAddress}
                        </span>
                    </div>
                </div>
            )}
        </div>
    )
}

export const renderMassTime = ({renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {
    const {
        title,
        church,
        description,
        start_time,
        language,
        special_event_flag,
        special_event_datetime,
        sunday_mass_flag,
    } = item ?? {}

    const {name} = church ?? {}
    const fullAddress = getFullAddress(church)
    const startTime = dayjs(start_time, "HH:mm:ss");
    const time = formatDate(startTime, 'HH:mm')

    const week_label = renderDayOfWeek(item?.weekdays);

    return (
        <LocalContext.Consumer>
            {(localItem) => (
                <LayoutContext.Consumer>
                    {({isSm}) => (
                        <Translate key={index}>
                            {(t) => (
                                <div
                                    className="px-0 md:px-3 py-2 rounded-lg custom-item-render custom-render-border relative">
                                    <div className="flex items-start md:items-center gap-2 mb-2">
                                        {renderIfElse(
                                            special_event_flag === 1,
                                            <TooltipApp title={t('special mass times')}
                                                        classNames={{root: "font-medium text-xs italic"}}>
                                                <GiJeweledChalice size={14} className="text-green-500"/>
                                            </TooltipApp>,
                                            <RiMapPinTimeFill size={14} style={{marginTop: isSm && 3}}
                                                              className="text-blue-600"/>
                                        )}
                                        <div className="flex flex-col md:flex-row flex-1 gap-x-4 gap-y-1 leading-tight">
                                            <div className="flex gap-x-3">
                                        <span style={{letterSpacing: '0.15em'}} className="font-bold text-blue-500">
                                            {renderIfElse(
                                                special_event_flag === 1,
                                                formatDate(special_event_datetime, 'HH:mm - DD/MM/YYYY'),
                                                time
                                            )}
                                        </span>
                                                <span className="flex items-center gap-3">
                                            <GoDotFill size={12} className="text-color-400"/>
                                            <span className="font-bold text-color-000 italic">
                                                {week_label}
                                            </span>
                                        </span>
                                            </div>
                                            <span className="flex items-center gap-2">
                                        <FaChurch size={14} className="text-primary-300"/>
                                        <span onClick={() => {
                                            handleAction(CRUD.READ, item)
                                        }}
                                              className="font-bold text-sm md:text-base text-primary hover:text-primary-600 cursor-pointer">
                                              {name}
                                        </span>
                                    </span>
                                        </div>
                                    </div>
                                    <div className="flex items-start md:items-center gap-2 mb-1 leading-snug">
                                        <BiSolidMapPin size={12} style={{marginTop: 2}} className="text-color-500"/>
                                        <span className="flex-1 font-semibold text-xs text-color-200 italic">
                                    {fullAddress}
                                </span>
                                    </div>
                                    <div style={{marginLeft: 1}}
                                         className="flex items-start md:items-center gap-2 leading-snug">
                                        <GoDotFill size={11} style={{marginTop: 2}} className="text-color-400"/>
                                        <span className="flex-1 text-xs leading-tight">
                                    <span className="font-bold text-color-000">
                                        {title}
                                    </span>
                                            {renderIf(
                                                description,
                                                <span className="ml-1 text-color-400 italic">
                                          {`: ${description}`}
                                      </span>
                                            )}
                                            {renderIf(
                                                language !== localItem?.lang,
                                                <span
                                                    className="ml-4 font-bold text-primary italic opacity-60">{t(language)}</span>
                                            )}
                                </span>
                                    </div>
                                    {_.isFunction(renderContextMenu) && (
                                        <div className="absolute right-5 top-5 contextIcon">
                                            {renderContextMenu(item)}
                                        </div>
                                    )}
                                </div>
                            )}
                        </Translate>
                    )}
                </LayoutContext.Consumer>
            )}
        </LocalContext.Consumer>
    )
}